import { useCallback } from "react";
import { PrivatePageHeader } from "views/components/headers";
import { ButtonPrivateHeader } from "views/components/controles/buttons";
import { DesfazerIcon, FiltroIcon, MenuIcon, VoltarIcon } from "views/components/icons";
import { useMenuPrincipal } from "services/app";
import { useThemeQueries } from "views";
import { useHistory, useLocation } from "react-router-dom";
import { isEmpty } from "lodash";
import { PesquisaGerentes } from "./components/pesquisa-gerentes/pesquisa-gerentes";
import { RevendedorListSearchProps } from "views/pages/private/revendedor/components/revendedor-list/revendedor-list-search-props";

export interface GerentesHeaderProps {
  openPesquisa: boolean;
  setOpenPesquisa: (state: boolean) => any;
  setSearchProps: (props: RevendedorListSearchProps) => any;
  titulo: string,
}

export interface LocationProps {
  from: {
    pathname: string,
    page?: number;
  }
}

export const GerentesHeader = ({
  openPesquisa,
  setOpenPesquisa,
  setSearchProps,
  titulo
}: GerentesHeaderProps) => {
  const { abrirMenu } = useMenuPrincipal();
  const { isMobile } = useThemeQueries();
  const history = useHistory()
  const { state } = useLocation<LocationProps>()

  const leftArea = useCallback(
    () =>
      isMobile ? (titulo === 'Gerentes Comerciais' ?
      (
        <ButtonPrivateHeader
          icon={<MenuIcon tipo="PRIVATE_HEADER"></MenuIcon>}
          tooltip="Menu"
          onClick={abrirMenu}
        ></ButtonPrivateHeader>
      ) : <ButtonPrivateHeader
        icon={<VoltarIcon tipo="PRIVATE_HEADER"></VoltarIcon>}
        tooltip="Voltar"
        onClick={() => {
          if (!state?.from?.pathname || isEmpty(state.from.pathname)) {
            history.push('/gerentes')
            return
          }
          if (state.from.page) {
            history.push('/gerentes?page=' + state.from.page)
            return
          }
          history.goBack()
        }}
      ></ButtonPrivateHeader>) : (titulo !== 'Gerentes Comerciais') ? (
        <ButtonPrivateHeader
          icon={<VoltarIcon tipo="PRIVATE_HEADER" />}
          tooltip="Voltar"
          onClick={() => {
            if (!state?.from?.pathname || isEmpty(state.from.pathname)) {
              history.push('/gerentes')
              return
            }
            if(state.from.page){
              history.push('/gerentes?page=' + state.from.page)
              return
            }
            history.goBack()
          }}
        />
      ) : null,
    [isMobile, abrirMenu, titulo, state, history]
  );

  const rightArea = useCallback(
    () => titulo === 'Gerentes Comerciais' ? (
      <ButtonPrivateHeader
        icon={
          openPesquisa ? (
            <DesfazerIcon tipo="PRIVATE_HEADER"></DesfazerIcon>
          ) : (
            <FiltroIcon tipo="PRIVATE_HEADER"></FiltroIcon>
          )
        }
        tooltip={!openPesquisa ? "Pesquisar" : "Voltar"}
        onClick={() => setOpenPesquisa(!openPesquisa)}
      ></ButtonPrivateHeader>
    ) : null,
    [titulo, openPesquisa, setOpenPesquisa]
  );

  const closePesquisaWrapper = useCallback(() => {
    setOpenPesquisa(false);
  }, [setOpenPesquisa]);

  const onPesquisar = useCallback(
    (props: RevendedorListSearchProps) => {
      setSearchProps(props);
    },
    [setSearchProps]
  );

  const pesquisa = useCallback(() => titulo === 'Gerentes Comerciais' ? (
    <PesquisaGerentes
      isOpened={!isMobile || openPesquisa!}
      onCloseSearch={closePesquisaWrapper}
      onPesquisar={onPesquisar}
    />
  ) : <></>, [closePesquisaWrapper, isMobile, onPesquisar, openPesquisa, titulo])

  return (
    <>
      <PrivatePageHeader
        title={titulo}
        leftArea={leftArea()}
        rightArea={isMobile ? rightArea() : pesquisa()}
        bottomArea={isMobile ? pesquisa() : undefined}
      />
    </>
  );
};
